<template>
    <div>
        <div style="width: 200px;height: calc(100vh - 20px);position: absolute;top: 0px;left: 0px;background-color: #282FA3;">
            <el-menu :default-active="activeIndex" router>
                <div style="height: 80px;background-color: #282FA3;position: relative;">
                    <div class="home_logo" style="width: 164px;height: 44px;"></div>
                </div>
                <el-menu-item v-for="(item, index) in navList" :key="index" :index="item.name">{{ item.navItem }}</el-menu-item>
            </el-menu>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeIndex: '',
                navList:[
                    {name: '/Home', navItem: '首页'},
                    // {name: '/Resources', navItem: '资源列表'},
                    {name: '/Course', navItem: '课程管理'},
                    {name: '/Notice', navItem: '通知管理'},
                    {name: '/Message', navItem: '私信管理'},
                    // {name: '/Examination', navItem: '考试'},
                    // {name: '/Achievement', navItem: '成绩查询'},
                    {name: '/PersonCenter', navItem: '个人中心'},
                ],
                screenHeight: document.documentElement.clientHeight,
            }
        },
        mounted() {
            
            // console.log('lccc', this.$parent.activeIndex)
            this.activeIndex = this.$parent.activeIndex;
        },
        methods: {
        }
    }
</script>
<style scoped>
    .el-menu > li {
        background-color: #282FA3;
        color: #fff;
    }
    .el-menu-item.is-active { 
        background: #555CDA !important;
        opacity: 1 !important;
     }
     .home_logo{
        background: url('~@/assets/images/login_logo.png') center center no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 30%;
        left: 10%;
     }
</style>